import styled from 'styled-components';

export const StyledPreview = styled.div<{ branding: any }>`
  height: 100%;
  max-height: calc(90vh - 100px);
  // overflow: auto;
  padding: 0 50px;
  background: ${({ branding }) =>
    branding?.primary_background_color
      ? branding.primary_background_color
      : '#ebeff3'};

  .builder {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    zoom: 0.9;
    background: ${({ branding }) =>
      branding?.primary_background_color
        ? branding.primary_background_color
        : '#ebeff3'};
    padding-top: 40px;
    --brand-color: ${({ branding }) => branding?.brand_color || ''};
    --question-text-color: ${({ branding }) =>
      branding?.question_text_color
        ? branding.question_text_color
        : 'var(--color-elephant-900)'};
    --question-background: ${({ branding }) =>
      branding?.question_background_color
        ? branding.question_background_color
        : '#fff'};

    .brand-logo img {
      width: 140px;
      margin-bottom: 20px;
    }

    .text-lg {
      color: var(--question-text-color);
      font-size: 16px;
      font-weight: 600;
    }

    p {
      margin: 10px 0;
      color: var(--color-smoke-800);
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
    }
    .field {
      display: flex;
      align-items: flex-start;
      padding: 20px 20px 0;
      width: 100%;
    }
    .add-step {
      user-select: none;
      background: #ffffff;
      box-shadow: 0px 2px 5px rgba(18, 52, 77, 0.1);
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 52px;
      height: 52px;

      span {
        font-size: 30px;
        margin-top: -5px;
      }
    }

    section {
      width: 100%;
    }

    .builder-header {
      margin: 11px 0 21px;
      .editable-text {
        line-height: 1.8;
      }
    }

    .nps-title {
      font-size: 16px;
      font-weight: 600;
      margin-left: 30px;
      margin-top: 20px;
      padding-bottom: 20px;
    }

    .open .nps-title {
      margin-top: 40px;
      padding-bottom: 0;
    }

    .question-container {
      padding: 20px 30px;
      text-align: left;
    }

    .section-configuration {
      display: flex;
      justify-content: space-between;
      margin: 25px 35px 0;
      .form-field {
        width: calc(50% - 10px);

        label {
          display: block;
          font-size: var(--font-size-12);
          color: var(--color-smoke-700);
          font-weight: 500;
        }
        .option {
          margin-top: 5px;

          .dropdown-button {
            min-height: 35px;
          }
        }
      }
    }

    .section {
      background: var(--question-background);
      border-radius: 4px;
      width: 100%;
      margin: 20px 0;
      box-shadow: var(--shadow-md);
      transform: scale(1);
      transition: transform 400ms ease 0ms, visibility 200ms ease 0ms,
        opacity 200ms ease 0ms;

      &.open {
        box-shadow: 0px 2px 16px rgba(18, 52, 77, 0.1);

        .section-title {
          opacity: 1;
        }
      }

      .section-description.required::after {
        content: '*';
        position: relative;
        top: -2px;
        font-size: 14px;
        color: var(--text-danger);
        padding-left: 3px;
        font-weight: 700;
      }

      .section-title {
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 14px;
        color: var(--color-elephant-850);
        opacity: 0.45;

        .icon {
          margin-right: 5px;
        }

        .section-type {
          margin-right: 10px;
          padding-right: 10px;
          border-right: 1px solid var(--color-smoke-100);
        }
      }

      .section-type {
        display: flex;
        align-items: center;
      }

      .section-required {
        position: relative;
        margin-left: 10px;
        display: flex;
        align-items: center;
        padding: 5px 10px;
        background: #ebeff3;
        border-radius: 4px;
      }

      .section-question {
        margin: 10px 25px 0;
        padding: 10px 0 0 0;
      }
      .section-description {
        font-weight: 600;
        font-size: 16px;
        margin: 0;
      }
      .section-content {
        padding: 10px;
      }
      .section-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #ffffff;
        border-radius: 6px 6px 0 0;
        padding: 15px 5px 7px 25px;
        min-height: 40px;
        border-bottom: 1px solid #ebeff3;
        background: #fff;
        padding: 5px 5px 5px 15px;
        button {
          background: var(--color-smoke-25);
          border-color: var(--color-smoke-50);
        }
        button:hover {
          background: var(--color-smoke-50);
          border-color: var(--color-smoke-100);
        }
      }
    }
  }
`;

export const StyledLogo = styled.div`
  display: flex;
  align-items: center;
  .logoPlaceholder {
    background: #f7f7f7;
    border: 1px dashed var(--color-smoke-800);
    box-sizing: border-box;
    border-radius: 5px;
    padding: 6px;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 11px;
    line-height: 15px;
    color: #12344d;
    opacity: 0.2;
    width: 44px;
    height: 44px;
    text-align: center;
  }

  .companyname {
    margin-left: 10px;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #12344d;
  }
`;
